import { createContext } from 'react';
import { UserItem } from '../api/models/schema';

interface AppUserContextProps {
  appUser: UserItem | undefined; 
  refreshUser: () => void;
}

export const AppUserContext = createContext<AppUserContextProps>({
    appUser: undefined,
    refreshUser: () => {}
});